import moment from 'moment';

export const calculateAge = (birthday: string) => {
    if (!birthday) {
        return { years: 0, months: 0 };
    }

    const today = new Date();
    const [birthYear, birthMonth] = birthday.split('-').map(Number);

    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth() + 1;

    let years = currentYear - birthYear;
    let months = currentMonth - birthMonth;

    if (months < 0) {
        years--;
        months += 12;
    }
    if (months === 0) {
        months = 1;
    }
    return {
        years: years > 0 ? years : 0,
        months: months
    };
};

interface formatDateTimeOptions {
    returnDefault?: null | '',
    onlyTime?: boolean,
    currentformat?: string
}

export const formatDateTime = (datetime?: string | Date | null, format?: string, options?: formatDateTimeOptions) => {
    if (!datetime) return options?.returnDefault ?? null;
    if (options?.onlyTime && options?.currentformat) {
        return moment(datetime, [moment.ISO_8601, options.currentformat]).format(format);
    }
    if (datetime instanceof Date) return moment(datetime).format(format);
    return moment(new Date(datetime)).format(format);
};

// Kiểm tra có phải là ngày quá khứ không
export function isExpired(watchExpiredDate) {
    if (!watchExpiredDate) {
        return false; // Trường hợp '', undefined, null, 0, false
    }

    const date = moment(watchExpiredDate);

    // Kiểm tra nếu không phải là ngày hợp lệ
    if (!date.isValid()) {
        return false;
    }

    // So sánh với ngày hiện tại (theo ngày, không tính giờ)
    return date.isBefore(moment(), 'day');
}
